import * as i0 from '@angular/core';
import { TemplateRef, Component, ViewEncapsulation, ChangeDetectionStrategy, Input, ViewChild, Directive, EventEmitter, forwardRef, ContentChildren, Output, Pipe, NgModule } from '@angular/core';
import { startWith, delay, map, Observable, debounceTime } from 'rxjs';
import * as i5 from '@angular/forms';
import { NG_VALUE_ACCESSOR, FormsModule } from '@angular/forms';
import * as i1 from '@angular/cdk/overlay';
import * as i2 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i3 from '@angular/material/autocomplete';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import * as i4 from '@angular/material/core';
import * as i6 from '@niceltd/sol/button';
import { ButtonModule } from '@niceltd/sol/button';
import * as i8 from '@niceltd/sol/translation';
import { TranslationModule } from '@niceltd/sol/translation';
function AutoCompleteOptionComponent_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0);
  }
}
const _c0 = ["*"];
const _c1 = ["searchInput"];
function AutoCompleteComponent_ng_template_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(0, "svg", 13);
    i0.ɵɵelement(1, "path", 14);
    i0.ɵɵelementEnd();
  }
}
function AutoCompleteComponent_sol_button_10_Template(rf, ctx) {
  if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "sol-button", 15);
    i0.ɵɵlistener("onClick", function AutoCompleteComponent_sol_button_10_Template_sol_button_onClick_0_listener() {
      i0.ɵɵrestoreView(_r9);
      const ctx_r8 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r8.clearSearchText());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵnextContext();
    const _r3 = i0.ɵɵreference(9);
    i0.ɵɵproperty("variant", "text")("iconPositionedFront", _r3)("size", "large")("ariaLabel", "clear icon");
  }
}
function AutoCompleteComponent_ng_container_13_mat_option_1_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function AutoCompleteComponent_ng_container_13_mat_option_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-option", 17);
    i0.ɵɵtemplate(1, AutoCompleteComponent_ng_container_13_mat_option_1_ng_container_1_Template, 1, 0, "ng-container", 18);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r11 = ctx.$implicit;
    i0.ɵɵproperty("value", item_r11.name)("id", item_r11.id)("disabled", item_r11.disabled);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", item_r11.autoCompleteContent);
  }
}
function AutoCompleteComponent_ng_container_13_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, AutoCompleteComponent_ng_container_13_mat_option_1_Template, 2, 4, "mat-option", 16);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind1(2, 1, ctx_r6.autocompleteOption$));
  }
}
function AutoCompleteComponent_ng_container_14_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "mat-option", 19);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵproperty("disabled", true);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 2, "noItemsFound"));
  }
}
const _c2 = ["containerEleRef"];
class AutoCompleteOptionComponent {
  constructor() {
    this.disabled = false;
    this.autoCompleteContent = null;
  }
  static {
    this.ɵfac = function AutoCompleteOptionComponent_Factory(t) {
      return new (t || AutoCompleteOptionComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: AutoCompleteOptionComponent,
      selectors: [["sol-autocomplete-option"]],
      viewQuery: function AutoCompleteOptionComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(TemplateRef, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.autoCompleteContent = _t.first);
        }
      },
      inputs: {
        id: "id",
        name: "name",
        disabled: "disabled"
      },
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function AutoCompleteOptionComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵtemplate(0, AutoCompleteOptionComponent_ng_template_0_Template, 1, 0, "ng-template");
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AutoCompleteOptionComponent, [{
    type: Component,
    args: [{
      selector: 'sol-autocomplete-option',
      template: '<ng-template><ng-content></ng-content></ng-template>',
      encapsulation: ViewEncapsulation.None,
      changeDetection: ChangeDetectionStrategy.OnPush
    }]
  }], null, {
    id: [{
      type: Input
    }],
    name: [{
      type: Input
    }],
    disabled: [{
      type: Input
    }],
    autoCompleteContent: [{
      type: ViewChild,
      args: [TemplateRef]
    }]
  });
})();
class StickyPositionOnScrollDirective {
  constructor(elementRef, renderer, autocompleteTrigger) {
    this.elementRef = elementRef;
    this.renderer = renderer;
    this.autocompleteTrigger = autocompleteTrigger;
    this.autocompletePanelSelector = '.cdk-overlay-pane .mat-mdc-autocomplete-panel';
  }
  ngAfterViewInit() {
    const autocomplete = this.autocompleteTrigger.autocomplete;
    if (autocomplete) {
      this.openSubscription = autocomplete.opened.subscribe(() => {
        const panel = document.querySelector(this.autocompletePanelSelector);
        if (panel) {
          // move autocomplete-panel into the input autocomplete container.
          this.renderer.appendChild(this.elementRef.nativeElement.parentElement.parentElement, panel);
          this.renderer.setStyle(panel, 'top', `${this.elementRef.nativeElement.parentElement.offsetHeight}px`);
          this.renderer.setStyle(panel, 'width', `${this.elementRef.nativeElement.parentElement.offsetWidth}px`);
        }
      });
    }
  }
  ngOnDestroy() {
    if (this.openSubscription) {
      this.openSubscription.unsubscribe();
    }
  }
  static {
    this.ɵfac = function StickyPositionOnScrollDirective_Factory(t) {
      return new (t || StickyPositionOnScrollDirective)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(i3.MatAutocompleteTrigger));
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: StickyPositionOnScrollDirective,
      selectors: [["", "stickyPositionOnScroll", ""]]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(StickyPositionOnScrollDirective, [{
    type: Directive,
    args: [{
      selector: '[stickyPositionOnScroll]'
    }]
  }], () => [{
    type: i0.ElementRef
  }, {
    type: i0.Renderer2
  }, {
    type: i3.MatAutocompleteTrigger
  }], null);
})();
class AutoCompleteComponent {
  constructor(cdr, overlayContainer) {
    this.cdr = cdr;
    this.overlayContainer = overlayContainer;
    this.minimumSearchTextLength = 3;
    this.optionSelected = new EventEmitter();
    this.clearedSearchText = new EventEmitter();
    this.dropdownVisible = new EventEmitter();
    this.searchText = '';
    this._change = _ => {};
    this._controlValueAccessorTouchedFn = () => {};
  }
  ngAfterContentInit() {
    this.autocompleteOption$ = this.autocompleteOptions?.changes.pipe(startWith('')).pipe(delay(0)).pipe(map(() => {
      return this.autocompleteOptions?.toArray();
    }));
    this.overlayContainer.getContainerElement().setAttribute('role', 'region');
  }
  setFocus() {
    this.searchInput.nativeElement.focus();
  }
  clearSearchText() {
    this.searchText = '';
    this._change(this.searchText);
    this.clearedSearchText.emit();
  }
  dropdownOpened() {
    this.dropdownVisible.emit(true);
  }
  dropdownClosed() {
    this.dropdownVisible.emit(false);
  }
  searchChange(value) {
    this._change(value);
  }
  selectedOption(event) {
    this.optionSelected.emit(event);
  }
  writeValue(value) {
    this.searchText = value;
    this.cdr.detectChanges();
  }
  registerOnChange(fn) {
    this._change = fn;
  }
  registerOnTouched(fn) {
    this._controlValueAccessorTouchedFn = fn;
  }
  static {
    this.ɵfac = function AutoCompleteComponent_Factory(t) {
      return new (t || AutoCompleteComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.OverlayContainer));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: AutoCompleteComponent,
      selectors: [["sol-autocomplete"]],
      contentQueries: function AutoCompleteComponent_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, AutoCompleteOptionComponent, 4);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.autocompleteOptions = _t);
        }
      },
      viewQuery: function AutoCompleteComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c1, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.searchInput = _t.first);
        }
      },
      inputs: {
        placeholder: "placeholder",
        minimumSearchTextLength: "minimumSearchTextLength",
        ariaLabel: "ariaLabel"
      },
      outputs: {
        optionSelected: "optionSelected",
        clearedSearchText: "clearedSearchText",
        dropdownVisible: "dropdownVisible"
      },
      features: [i0.ɵɵProvidersFeature([{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => AutoCompleteComponent),
        multi: true
      }])],
      decls: 15,
      vars: 9,
      consts: [[1, "sol-auto-complete"], ["matAutocompleteOrigin", "", 1, "input-wrapper"], ["origin", "matAutocompleteOrigin"], [1, "svg-container"], ["width", "16", "height", "16", "viewBox", "0 0 16 16", "fill", "none", "xmlns", "http://www.w3.org/2000/svg"], ["d", "M0 6.4C0 9.92 2.88 12.8 6.4 12.8C7.84 12.8 9.2 12.32 10.32 11.44L14.64 15.76C14.96 16.08 15.44 16.08 15.76 15.76C16.08 15.44 16.08 14.96 15.76 14.64L11.44 10.32C12.32 9.2 12.8 7.84 12.8 6.4C12.8 2.88 9.92 0 6.4 0C2.88 0 0 2.88 0 6.4ZM1.6 6.4C1.6 3.76 3.76 1.6 6.4 1.6C9.04 1.6 11.2 3.76 11.2 6.4C11.2 9.04 9.04 11.2 6.4 11.2C3.76 11.2 1.6 9.04 1.6 6.4Z", "fill", "#3F5C69"], ["type", "text", "aria-controls", "autocompletePanel", "stickyPositionOnScroll", "", 3, "placeholder", "matAutocomplete", "ngModel", "matAutocompleteConnectedTo", "ngModelChange"], ["searchInput", ""], ["LeadingIcon", ""], [3, "variant", "iconPositionedFront", "size", "ariaLabel", "onClick", 4, "ngIf"], ["id", "autocompletePanel", 3, "disableRipple", "optionSelected", "closed", "opened"], ["auto", "matAutocomplete"], [4, "ngIf"], ["width", "16", "height", "16", "viewBox", "0 0 20 20", "fill", "none", "xmlns", "http://www.w3.org/2000/svg"], ["fill-rule", "evenodd", "clip-rule", "evenodd", "d", "M4.41058 4.41107C4.73602 4.08563 5.26366 4.08563 5.58909 4.41107L9.99984 8.82181L14.4106 4.41107C14.736 4.08563 15.2637 4.08563 15.5891 4.41107C15.9145 4.73651 15.9145 5.26414 15.5891 5.58958L11.1783 10.0003L15.5891 14.4111C15.9145 14.7365 15.9145 15.2641 15.5891 15.5896C15.2637 15.915 14.736 15.915 14.4106 15.5896L9.99984 11.1788L5.58909 15.5896C5.26366 15.915 4.73602 15.915 4.41058 15.5896C4.08514 15.2641 4.08514 14.7365 4.41058 14.4111L8.82133 10.0003L4.41058 5.58958C4.08514 5.26414 4.08514 4.73651 4.41058 4.41107Z", "fill", "currentColor"], [3, "variant", "iconPositionedFront", "size", "ariaLabel", "onClick"], [3, "value", "id", "disabled", 4, "ngFor", "ngForOf"], [3, "value", "id", "disabled"], [4, "ngTemplateOutlet"], [1, "item-not-found", 3, "disabled"]],
      template: function AutoCompleteComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 0)(1, "div", 1, 2)(3, "div", 3);
          i0.ɵɵnamespaceSVG();
          i0.ɵɵelementStart(4, "svg", 4);
          i0.ɵɵelement(5, "path", 5);
          i0.ɵɵelementEnd()();
          i0.ɵɵnamespaceHTML();
          i0.ɵɵelementStart(6, "input", 6, 7);
          i0.ɵɵtwoWayListener("ngModelChange", function AutoCompleteComponent_Template_input_ngModelChange_6_listener($event) {
            i0.ɵɵtwoWayBindingSet(ctx.searchText, $event) || (ctx.searchText = $event);
            return $event;
          });
          i0.ɵɵlistener("ngModelChange", function AutoCompleteComponent_Template_input_ngModelChange_6_listener($event) {
            return ctx.searchChange($event);
          });
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(8, AutoCompleteComponent_ng_template_8_Template, 2, 0, "ng-template", null, 8, i0.ɵɵtemplateRefExtractor)(10, AutoCompleteComponent_sol_button_10_Template, 1, 4, "sol-button", 9);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(11, "mat-autocomplete", 10, 11);
          i0.ɵɵlistener("optionSelected", function AutoCompleteComponent_Template_mat_autocomplete_optionSelected_11_listener($event) {
            return ctx.selectedOption($event);
          })("closed", function AutoCompleteComponent_Template_mat_autocomplete_closed_11_listener() {
            return ctx.dropdownClosed();
          })("opened", function AutoCompleteComponent_Template_mat_autocomplete_opened_11_listener() {
            return ctx.dropdownOpened();
          });
          i0.ɵɵtemplate(13, AutoCompleteComponent_ng_container_13_Template, 3, 3, "ng-container", 12)(14, AutoCompleteComponent_ng_container_14_Template, 4, 4, "ng-container", 12);
          i0.ɵɵelementEnd()();
        }
        if (rf & 2) {
          const _r0 = i0.ɵɵreference(2);
          const _r5 = i0.ɵɵreference(12);
          i0.ɵɵadvance(6);
          i0.ɵɵproperty("placeholder", "Search for " + ctx.placeholder)("matAutocomplete", _r5);
          i0.ɵɵtwoWayProperty("ngModel", ctx.searchText);
          i0.ɵɵproperty("matAutocompleteConnectedTo", _r0);
          i0.ɵɵattribute("aria-label", "Search for " + ctx.ariaLabel);
          i0.ɵɵadvance(4);
          i0.ɵɵproperty("ngIf", ctx.searchText && ctx.searchText.length > 0);
          i0.ɵɵadvance();
          i0.ɵɵproperty("disableRipple", true);
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngIf", ctx.autocompleteOptions && ctx.autocompleteOptions.toArray().length > 0);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.autocompleteOptions && ctx.autocompleteOptions.toArray().length === 0 && ctx.searchText && ctx.searchText.length >= ctx.minimumSearchTextLength);
        }
      },
      dependencies: [i2.NgForOf, i2.NgIf, i2.NgTemplateOutlet, i3.MatAutocomplete, i4.MatOption, i3.MatAutocompleteTrigger, i3.MatAutocompleteOrigin, i5.DefaultValueAccessor, i5.NgControlStatus, i5.NgModel, i6.ButtonComponent, StickyPositionOnScrollDirective, i2.AsyncPipe, i8.TranslationPipe],
      styles: [".sol-auto-complete{position:relative}.sol-auto-complete .mat-mdc-autocomplete-panel.mat-mdc-autocomplete-visible{margin-top:5px;position:absolute;z-index:1000;left:0;border-radius:var(--radii-small-allcorners);max-height:16.875rem;padding:0}.sol-auto-complete .input-wrapper{box-sizing:border-box;height:2.25rem;gap:1rem;border:1px solid var(--color-globalstate-inactive-border);border-radius:var(--radii-small-allcorners);background-color:#fff;display:inline-flex;align-items:center;width:100%;outline:none}.sol-auto-complete .input-wrapper .svg-container{margin-left:.75rem;display:flex}.sol-auto-complete .input-wrapper .svg-container svg{height:1rem;width:1rem;background-size:contain}.sol-auto-complete .input-wrapper input{width:100%;background:none;outline:none;border:none;font-size:var(--typography-opensans-body-body3-font-size)}.mat-mdc-autocomplete-panel{background:#fff;border:1px solid var(--color-interface-border1)}.mat-mdc-autocomplete-panel:not([class*=mat-elevation-z]){box-shadow:0 4px 6px #0000003d}.mat-mdc-autocomplete-panel .mat-mdc-option{height:auto;line-height:auto}.mat-mdc-autocomplete-panel .mat-mdc-option:hover:not(.mat-option-disabled),.mat-mdc-autocomplete-panel .mat-mdc-option:focus:not(.mat-option-disabled){background-color:var(--color-button-basic-pressed)}.mat-mdc-autocomplete-panel .mat-mdc-option .mat-pseudo-checkbox-minimal{display:none}.mat-mdc-autocomplete-panel .mat-mdc-option .mdc-list-item__primary-text{width:100%}.mat-mdc-autocomplete-panel .mat-mdc-option.mdc-list-item--selected:not(.mdc-list-item--disabled) .mdc-list-item__primary-text{color:var(--interface-text700)}.mat-mdc-autocomplete-panel .mat-mdc-option.mdc-list-item--selected:not(.mdc-list-item--disabled):not(.mat-mdc-option-multiple){background-color:transparent}.mat-mdc-autocomplete-panel .mat-mdc-option.mdc-list-item--selected:not(.mdc-list-item--disabled):not(.mat-mdc-option-multiple):hover:not(.mdc-list-item--disabled){background-color:var(--color-button-basic-pressed)}.mat-mdc-autocomplete-panel .mat-mdc-option.mat-mdc-option-active.mat-mdc-option-active.mdc-list-item{background:var(--color-interface-background50);outline:none}.mat-mdc-autocomplete-panel .mat-mdc-option.mat-mdc-option-active:not(.mdc-list-item--disabled){background-color:transparent;outline:1px solid var(--color-globalstate-focus);outline-offset:-3px}.mat-mdc-autocomplete-panel .mat-mdc-option.mat-mdc-option-active:not(.mdc-list-item--disabled):first-child{border-top-left-radius:var(--radii-small-allcorners)}.mat-mdc-autocomplete-panel .mat-mdc-option.mat-mdc-option-active:not(.mdc-list-item--disabled):last-child{border-bottom-left-radius:var(--radii-small-allcorners);border-bottom-right-radius:var(--radii-small-allcorners)}.mat-mdc-autocomplete-panel .item-not-found{color:#5b7c8c}*{scrollbar-width:thin;scrollbar-color:var(--color-globalstate-active-border) transparent}*::-webkit-scrollbar{width:8px}*::-webkit-scrollbar-corner{display:none}*::-webkit-scrollbar-track{background:transparent;background-clip:content-box;border-radius:5pt;border:3pt solid transparent}*::-webkit-scrollbar-thumb{background-color:var(--color-globalstate-active-border);border-radius:5pt;border:2pt solid transparent;background-clip:content-box}*::-webkit-scrollbar-thumb:vertical:hover{background:var(--color-globalstate-active-border);border-radius:5pt;border:none}* ::-webkit-scrollbar-track:vertical:hover{background:transparent;border:none}\n"],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AutoCompleteComponent, [{
    type: Component,
    args: [{
      selector: 'sol-autocomplete',
      template: `
    <div class="sol-auto-complete">
      <div class="input-wrapper" matAutocompleteOrigin #origin="matAutocompleteOrigin">
        <div class="svg-container">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M0 6.4C0 9.92 2.88 12.8 6.4 12.8C7.84 12.8 9.2 12.32 10.32 11.44L14.64 15.76C14.96 16.08 15.44 16.08 15.76 15.76C16.08 15.44 16.08 14.96 15.76 14.64L11.44 10.32C12.32 9.2 12.8 7.84 12.8 6.4C12.8 2.88 9.92 0 6.4 0C2.88 0 0 2.88 0 6.4ZM1.6 6.4C1.6 3.76 3.76 1.6 6.4 1.6C9.04 1.6 11.2 3.76 11.2 6.4C11.2 9.04 9.04 11.2 6.4 11.2C3.76 11.2 1.6 9.04 1.6 6.4Z"
              fill="#3F5C69"
            />
          </svg>
        </div>
        <input
          #searchInput
          type="text"
          [placeholder]="'Search for ' + placeholder"
          [attr.aria-label]="'Search for ' + ariaLabel"
          aria-controls="autocompletePanel"
          [matAutocomplete]="auto"
          stickyPositionOnScroll
          [(ngModel)]="searchText"
          (ngModelChange)="searchChange($event)"
          [matAutocompleteConnectedTo]="origin"
        />
        <ng-template #LeadingIcon>
          <svg width="16" height="16" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M4.41058 4.41107C4.73602 4.08563 5.26366 4.08563 5.58909 4.41107L9.99984 8.82181L14.4106 4.41107C14.736 4.08563 15.2637 4.08563 15.5891 4.41107C15.9145 4.73651 15.9145 5.26414 15.5891 5.58958L11.1783 10.0003L15.5891 14.4111C15.9145 14.7365 15.9145 15.2641 15.5891 15.5896C15.2637 15.915 14.736 15.915 14.4106 15.5896L9.99984 11.1788L5.58909 15.5896C5.26366 15.915 4.73602 15.915 4.41058 15.5896C4.08514 15.2641 4.08514 14.7365 4.41058 14.4111L8.82133 10.0003L4.41058 5.58958C4.08514 5.26414 4.08514 4.73651 4.41058 4.41107Z"
              fill="currentColor"
            />
          </svg>
        </ng-template>
        <sol-button
          *ngIf="searchText && searchText.length > 0"
          [variant]="'text'"
          [iconPositionedFront]="LeadingIcon"
          [size]="'large'"
          (onClick)="clearSearchText()"
          [ariaLabel]="'clear icon'"
        ></sol-button>
      </div>
      <mat-autocomplete
        #auto="matAutocomplete"
        id="autocompletePanel"
        [disableRipple]="true"
        (optionSelected)="selectedOption($event)"
        (closed)="dropdownClosed()"
        (opened)="dropdownOpened()"
      >
        <ng-container *ngIf="this.autocompleteOptions && this.autocompleteOptions.toArray().length > 0">
          <mat-option *ngFor="let item of autocompleteOption$ | async" [value]="item.name" [id]="item.id" [disabled]="item.disabled">
            <ng-container *ngTemplateOutlet="item.autoCompleteContent"> </ng-container>
          </mat-option>
        </ng-container>
        <ng-container
          *ngIf="
            this.autocompleteOptions && this.autocompleteOptions.toArray().length === 0 && searchText && searchText.length >= minimumSearchTextLength
          "
        >
          <mat-option class="item-not-found" [disabled]="true">{{ 'noItemsFound' | translate }}</mat-option>
        </ng-container>
      </mat-autocomplete>
    </div>
  `,
      encapsulation: ViewEncapsulation.None,
      changeDetection: ChangeDetectionStrategy.OnPush,
      providers: [{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => AutoCompleteComponent),
        multi: true
      }],
      styles: [".sol-auto-complete{position:relative}.sol-auto-complete .mat-mdc-autocomplete-panel.mat-mdc-autocomplete-visible{margin-top:5px;position:absolute;z-index:1000;left:0;border-radius:var(--radii-small-allcorners);max-height:16.875rem;padding:0}.sol-auto-complete .input-wrapper{box-sizing:border-box;height:2.25rem;gap:1rem;border:1px solid var(--color-globalstate-inactive-border);border-radius:var(--radii-small-allcorners);background-color:#fff;display:inline-flex;align-items:center;width:100%;outline:none}.sol-auto-complete .input-wrapper .svg-container{margin-left:.75rem;display:flex}.sol-auto-complete .input-wrapper .svg-container svg{height:1rem;width:1rem;background-size:contain}.sol-auto-complete .input-wrapper input{width:100%;background:none;outline:none;border:none;font-size:var(--typography-opensans-body-body3-font-size)}.mat-mdc-autocomplete-panel{background:#fff;border:1px solid var(--color-interface-border1)}.mat-mdc-autocomplete-panel:not([class*=mat-elevation-z]){box-shadow:0 4px 6px #0000003d}.mat-mdc-autocomplete-panel .mat-mdc-option{height:auto;line-height:auto}.mat-mdc-autocomplete-panel .mat-mdc-option:hover:not(.mat-option-disabled),.mat-mdc-autocomplete-panel .mat-mdc-option:focus:not(.mat-option-disabled){background-color:var(--color-button-basic-pressed)}.mat-mdc-autocomplete-panel .mat-mdc-option .mat-pseudo-checkbox-minimal{display:none}.mat-mdc-autocomplete-panel .mat-mdc-option .mdc-list-item__primary-text{width:100%}.mat-mdc-autocomplete-panel .mat-mdc-option.mdc-list-item--selected:not(.mdc-list-item--disabled) .mdc-list-item__primary-text{color:var(--interface-text700)}.mat-mdc-autocomplete-panel .mat-mdc-option.mdc-list-item--selected:not(.mdc-list-item--disabled):not(.mat-mdc-option-multiple){background-color:transparent}.mat-mdc-autocomplete-panel .mat-mdc-option.mdc-list-item--selected:not(.mdc-list-item--disabled):not(.mat-mdc-option-multiple):hover:not(.mdc-list-item--disabled){background-color:var(--color-button-basic-pressed)}.mat-mdc-autocomplete-panel .mat-mdc-option.mat-mdc-option-active.mat-mdc-option-active.mdc-list-item{background:var(--color-interface-background50);outline:none}.mat-mdc-autocomplete-panel .mat-mdc-option.mat-mdc-option-active:not(.mdc-list-item--disabled){background-color:transparent;outline:1px solid var(--color-globalstate-focus);outline-offset:-3px}.mat-mdc-autocomplete-panel .mat-mdc-option.mat-mdc-option-active:not(.mdc-list-item--disabled):first-child{border-top-left-radius:var(--radii-small-allcorners)}.mat-mdc-autocomplete-panel .mat-mdc-option.mat-mdc-option-active:not(.mdc-list-item--disabled):last-child{border-bottom-left-radius:var(--radii-small-allcorners);border-bottom-right-radius:var(--radii-small-allcorners)}.mat-mdc-autocomplete-panel .item-not-found{color:#5b7c8c}*{scrollbar-width:thin;scrollbar-color:var(--color-globalstate-active-border) transparent}*::-webkit-scrollbar{width:8px}*::-webkit-scrollbar-corner{display:none}*::-webkit-scrollbar-track{background:transparent;background-clip:content-box;border-radius:5pt;border:3pt solid transparent}*::-webkit-scrollbar-thumb{background-color:var(--color-globalstate-active-border);border-radius:5pt;border:2pt solid transparent;background-clip:content-box}*::-webkit-scrollbar-thumb:vertical:hover{background:var(--color-globalstate-active-border);border-radius:5pt;border:none}* ::-webkit-scrollbar-track:vertical:hover{background:transparent;border:none}\n"]
    }]
  }], () => [{
    type: i0.ChangeDetectorRef
  }, {
    type: i1.OverlayContainer
  }], {
    placeholder: [{
      type: Input
    }],
    minimumSearchTextLength: [{
      type: Input
    }],
    ariaLabel: [{
      type: Input
    }],
    searchInput: [{
      type: ViewChild,
      args: ['searchInput', {
        static: false
      }]
    }],
    autocompleteOptions: [{
      type: ContentChildren,
      args: [AutoCompleteOptionComponent]
    }],
    optionSelected: [{
      type: Output
    }],
    clearedSearchText: [{
      type: Output
    }],
    dropdownVisible: [{
      type: Output
    }]
  });
})();
class ResizeObservable extends Observable {
  constructor(elem) {
    super(subscriber => {
      const ro = new ResizeObserver(entries => {
        subscriber.next(entries);
      });
      ro.observe(elem); // Observe one or multiple elements
      return function unsubscribe() {
        ro.unobserve(elem);
        ro.disconnect();
      };
    });
  }
}
class TextHighlighterPipe {
  transform(originalText, textToFind, cssClass = 'highlighter') {
    // Return the original text if it's missing
    if (!textToFind) {
      return originalText;
    }
    /** Create a pattern based on the `textToFind` value.
          Replace some special characters with their escape sequences.
          Split the string by spaces and remove empty elements.
          Finally, join the remaining elements using '|' as the separator. */
    const pattern = textToFind.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
    // Create a regex based on the pattern - "case-insensitive".
    const regex = new RegExp(pattern, 'gi');
    // If `textToFind` exists, replace all the matches as bold else return the original text.
    return textToFind ? originalText.replace(regex, match => `<span class="${cssClass}">${match}</span>`) : originalText;
  }
  static {
    this.ɵfac = function TextHighlighterPipe_Factory(t) {
      return new (t || TextHighlighterPipe)();
    };
  }
  static {
    this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
      name: "solTextHighlighter",
      type: TextHighlighterPipe,
      pure: true
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TextHighlighterPipe, [{
    type: Pipe,
    args: [{
      name: 'solTextHighlighter'
    }]
  }], null, null);
})();
class SearchAutocompleteItemComponent {
  resizeHandler(elmWidth) {
    const {
      maxTextLength,
      ctx
    } = this.getCanvasContext(elmWidth);
    const pathWidth = ctx.measureText(this.path).width;
    this.presentedPath = this.path;
    if (maxTextLength > 0 && pathWidth >= maxTextLength) {
      this.adjustPathStringLength(maxTextLength, ctx);
    }
    this.cdr.detectChanges();
  }
  getCanvasContext(elmWidth) {
    const maxTextLength = elmWidth - 25 /* CONSTANTS.REMOVE_PADDING */;
    const canvas = document.createElement("canvas" /* CONSTANTS.CANVAS_ELEMENT */);
    const ctx = canvas.getContext("2d" /* CONSTANTS.CANVAS_CONTEXT */) || new CanvasRenderingContext2D();
    ctx.font = "12px Open Sans" /* CONSTANTS.FONT_STYLE */;
    return {
      maxTextLength,
      ctx
    };
  }
  adjustPathStringLength(maxTextLength, context) {
    const pathArray = this.path.split("/" /* CONSTANTS.DELIMITER */);
    const prefix = pathArray[0] + "/" /* CONSTANTS.DELIMITER */ + "..." /* CONSTANTS.ELLIPSIS */ + "/" /* CONSTANTS.DELIMITER */;
    let newPath = '';
    for (let i = 2; i < pathArray.length; i++) {
      newPath = prefix + pathArray.slice(i).join("/" /* CONSTANTS.DELIMITER */);
      if (maxTextLength >= context.measureText(newPath).width) {
        break;
      }
    }
    this.presentedPath = newPath;
  }
  constructor(cdr) {
    this.cdr = cdr;
    /**
     * text: string to display
     */
    this.text = '';
    /**
     * searchText: string to highlight in text
     */
    this.searchText = '';
    /**
     * path: string to display
     */
    this.path = '';
    this.presentedPath = '';
  }
  ngAfterViewInit() {
    if (this.containerEleRef && this.containerEleRef.nativeElement) {
      this.resizeSubscription = new ResizeObservable(this.containerEleRef.nativeElement).pipe(debounceTime(300)).subscribe(entries => {
        for (const entry of entries) {
          this.resizeHandler(entry.contentRect.width);
        }
      });
    }
  }
  ngOnDestroy() {
    if (!this.resizeSubscription?.closed) {
      this.resizeSubscription?.unsubscribe();
    }
  }
  static {
    this.ɵfac = function SearchAutocompleteItemComponent_Factory(t) {
      return new (t || SearchAutocompleteItemComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SearchAutocompleteItemComponent,
      selectors: [["sol-search-autocomplete-item"]],
      viewQuery: function SearchAutocompleteItemComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c2, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.containerEleRef = _t.first);
        }
      },
      inputs: {
        text: "text",
        searchText: "searchText",
        path: "path"
      },
      decls: 5,
      vars: 5,
      consts: [[1, "search-item-wrapper"], ["containerEleRef", ""], [1, "search-item-text", 3, "innerHtml"], [1, "search-item-path", 3, "innerHtml"]],
      template: function SearchAutocompleteItemComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 0, 1);
          i0.ɵɵelement(2, "span", 2);
          i0.ɵɵpipe(3, "solTextHighlighter");
          i0.ɵɵelement(4, "span", 3);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("innerHtml", i0.ɵɵpipeBind2(3, 2, ctx.text, ctx.searchText), i0.ɵɵsanitizeHtml);
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("innerHtml", ctx.presentedPath, i0.ɵɵsanitizeHtml);
        }
      },
      dependencies: [TextHighlighterPipe],
      styles: [".search-item-wrapper{min-height:38px;width:100%;min-width:250px;padding:8px 12px;display:flex;justify-content:space-between;flex-direction:column;font-style:var(--typography-opensans-body-body1-font-style);font-weight:var(--typography-opensans-body-body1-font-weight);font-family:var(--typography-opensans-body-body1-font-family)}.search-item-wrapper .search-item-text{color:var(--color-interface-text700);font-size:13px;line-height:120%}.search-item-wrapper .search-item-path{color:var(--color-interface-text450);font-size:12px;line-height:125%}.search-item-wrapper .highlighter{font-weight:bolder;color:#000}\n"],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SearchAutocompleteItemComponent, [{
    type: Component,
    args: [{
      selector: 'sol-search-autocomplete-item',
      encapsulation: ViewEncapsulation.None,
      changeDetection: ChangeDetectionStrategy.OnPush,
      template: "<div class=\"search-item-wrapper\" #containerEleRef>\n  <span class=\"search-item-text\" [innerHtml]=\"text | solTextHighlighter: searchText\"></span>\n  <span class=\"search-item-path\" [innerHtml]=\"presentedPath\"></span>\n</div>\n",
      styles: [".search-item-wrapper{min-height:38px;width:100%;min-width:250px;padding:8px 12px;display:flex;justify-content:space-between;flex-direction:column;font-style:var(--typography-opensans-body-body1-font-style);font-weight:var(--typography-opensans-body-body1-font-weight);font-family:var(--typography-opensans-body-body1-font-family)}.search-item-wrapper .search-item-text{color:var(--color-interface-text700);font-size:13px;line-height:120%}.search-item-wrapper .search-item-path{color:var(--color-interface-text450);font-size:12px;line-height:125%}.search-item-wrapper .highlighter{font-weight:bolder;color:#000}\n"]
    }]
  }], () => [{
    type: i0.ChangeDetectorRef
  }], {
    text: [{
      type: Input
    }],
    searchText: [{
      type: Input
    }],
    path: [{
      type: Input
    }],
    containerEleRef: [{
      type: ViewChild,
      args: ['containerEleRef', {
        static: false
      }]
    }]
  });
})();
class AutoCompleteModule {
  static {
    this.ɵfac = function AutoCompleteModule_Factory(t) {
      return new (t || AutoCompleteModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: AutoCompleteModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule, MatAutocompleteModule, FormsModule, ButtonModule, TranslationModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AutoCompleteModule, [{
    type: NgModule,
    args: [{
      declarations: [AutoCompleteComponent, AutoCompleteOptionComponent, SearchAutocompleteItemComponent, TextHighlighterPipe, StickyPositionOnScrollDirective],
      imports: [CommonModule, MatAutocompleteModule, FormsModule, ButtonModule, TranslationModule],
      exports: [AutoCompleteComponent, AutoCompleteOptionComponent, SearchAutocompleteItemComponent, TextHighlighterPipe]
    }]
  }], null, null);
})();

/**
 * Generated bundle index. Do not edit.
 */

export { AutoCompleteComponent, AutoCompleteModule, AutoCompleteOptionComponent, SearchAutocompleteItemComponent, TextHighlighterPipe };
